import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const ax = () => ({ withCredentials: true });

/**
 * Manage active/inactive list state for master data pages.
 *
 * @param {string} baseUrl - e.g. `${API}/api/subjects`
 * @returns { view, setView, list, inactiveCount, loading, error, reload }
 */
export default function useActiveInactive(baseUrl) {
  const [view, setView]                 = useState("active");
  const [list, setList]                 = useState([]);
  const [inactiveCount, setInactiveCount] = useState(0);
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const activeUrl   = baseUrl;
      const inactiveUrl = `${baseUrl}/inactive`;
      const [activeRes, inactiveRes] = await Promise.all([
        axios.get(activeUrl, ax()),
        axios.get(inactiveUrl, ax()).catch(() => ({ data: [] })),
      ]);
      setInactiveCount((inactiveRes.data || []).length);
      setList(view === "active" ? activeRes.data : inactiveRes.data);
    } catch {
      setError("Failed to load data.");
    } finally {
      setLoading(false);
    }
  }, [baseUrl, view]);

  useEffect(() => { reload(); }, [reload]);

  return { view, setView, list, inactiveCount, loading, error, reload };
}
